import bemCn from './bem-cn/index.js';
import { DEFAULT_CONFIG, DEFAULT_DELIMITERS } from './globals';
import { hyphenate, isString } from './utils.js';

export default {
  install(app, config = { delimiters: {} }) {
    const cfg = {
      ...DEFAULT_CONFIG,
      ...config,
      delimiters: {
        ...DEFAULT_DELIMITERS,
        ...config.delimiters,
      },
    };

    app.mixin({
      created() {
        const block = this.$options.block || this.$options.name;

        if (!isString(block)) {
          return;
        }

        const nsBlock = cfg.delimiters.ns + block;
        const generator = bemCn(cfg.hyphenate ? hyphenate(nsBlock) : nsBlock, cfg);

        this[cfg.methodName] = (...args) => generator(...args);
      },
    });
  },
};
